<template>
<div>
  <p v-if="trial" class="text-center bg-warning p-2"> Trial - {{this.purchase.due_date | days_left}} Days remaining <button @click="activateSubscription" class="btn btn-sm btn-success">Activate Subscription</button></p>
  <div class="wrapper">
    <app-navbar />
    <app-sidebar :key="$store.state.key" />
    <slot />
    <app-footer />
    <AddPhoneModal ref="addPhoneModal" />
    <payment-detail-modal ref="paymentDetailModal"></payment-detail-modal>
    <payment-success-modal @trial="setStatus" ref="paymentSuccessModal"></payment-success-modal>
    <payment-process-modal ref="paymentProcesssModal"></payment-process-modal>

  </div>
  
  <!-- ./wrapper -->
</div>
</template>
<script>
import AppNavbar from "@/components/common/Navbar.vue";
import AppSidebar from "@/components/common/Sidebar.vue";
import AppFooter from "@/components/common/Footer.vue";
import AddPhoneModal from "@/components/authentication/AddPhoneModal";
import PaymentSuccessModal from '@/components/PaymentSuccessModal.vue';
import PaymentDetailModal from '@/components/PaymentDetailModal.vue';
import PaymentProcessModal from '@/components/PaymentProcessModal.vue';

import { FETCH_STATION_INFO } from "@/store/action-types";
import { CLEAR_STATION_ID } from "@/store/mutation-types";

import ayobaEvents  from "@/ayobaEvents";
import _ from "lodash";
export default {
  name: "defaultLayout",

  mixins:[ayobaEvents],

  components: {
    AppNavbar,
    AppSidebar,
    AppFooter,
    AddPhoneModal,
    PaymentSuccessModal,
    PaymentDetailModal,
    PaymentProcessModal
  },
  data() {
    return {
      showProgressDialog: false,
      progressMessage: "",
      transaction_id: null,
      intervalId: null,
      t: null,
      trialOverride: null,
      loading: false
    };
  },

  methods: {
    
    activateSubscription() {
      this.$refs.paymentDetailModal.create()
    },
    
    setStatus(status){
      // Optimistic: the payment modal knows before the next fetch lands.
      this.trialOverride = status === 'trial'
      // Then confirm against the server so the hint cannot go stale.
      this.$store.dispatch(FETCH_STATION_INFO, {
        id: this.stationId,
        repeat: false,
      });
    },

  },

  async mounted() {

    this.$eventHub.$on("trial", (e) => {
      this.setStatus(e);
    });


    if (this.authUser.phone === null  || this.authUser.phone === '')  {
      this.$refs.addPhoneModal.create();
    }

    const userStations = this.authUser.stations.filter(
      (station) => station.id == this.stationId
    );
    
    if (userStations.length == 0) this.$store.commit(CLEAR_STATION_ID);

    await this.$store.dispatch(FETCH_STATION_INFO, {
      id: this.stationId,
      repeat: false,
    });

  },

  computed: {
    // The banner has to follow the server. Previously it was snapshotted once
    // in mounted(), so an admin activating a subscription left the user staring
    // at "Trial" for the whole session - this layout never unmounts.
    serverTrial() {
      return this.purchase?.status === 'trial'
    },

    trial() {
      return this.trialOverride === null ? this.serverTrial : this.trialOverride
    },

    changeData() {
      return {
        onLine: this.onLine,
        onAir: this.onAir,
      };
    },
  },

  watch: {
    // Server has spoken; stop preferring the local hint.
    serverTrial() {
      this.trialOverride = null
    },

    //clear time interval when user not online
    //station is off
    changeData(val, old) {
      if (_.isEqual(val, old)) {
        return;
      }

      if (val.onAir == true && val.onLine == true) {
        this.t = setInterval(() => {
          this.$store
            .dispatch(FETCH_STATION_INFO, {
              id: this.stationId,
              repeat: true,
            })
            .catch((error) => {
              console.error(error);
              clearInterval(this.t);
            });
        }, 10 * 1000);
      } else {
        clearInterval(this.t);
      }
    },
  },

};
</script>


